"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6371],{

/***/ 34489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ar": function() { return /* binding */ Layout; },
/* harmony export */   "Fe": function() { return /* binding */ Terms; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "gJ": function() { return /* binding */ BackGround; },
/* harmony export */   "zV": function() { return /* binding */ EmptySpace; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100vw;\n	min-height: 100%;\n	background-color: #000000;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-direction: row;\n	min-height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	flex: 1 0 auto;\n	position: relative;\n	min-height: 100%;\n	max-width: 100%;\n	min-width: 60vw;\n	display: flex;\n	flex-direction: column;\n	justify-content: center;\n	align-items: center;\n	background-color: white;\n	overflow-y: auto;\n	overflow-x: hidden;\n\n	@media screen and (max-device-height: 900px) {\n		justify-content: start;\n	}\n\n	.container {\n		margin: 20px auto;\n		width: 90vw;\n		max-width: 500px;\n		border-radius: 30px;\n		box-shadow: rgb(145 158 171 / 20%) 0px 0px 2px 0px,\n			rgb(145 158 171 / 12%) 0px 12px 24px 10px;\n		padding: 5%;\n\n		.description1 {\n			font-style: normal;\n			font-weight: 400;\n			font-size: 15px;\n			line-height: 17px;\n			color: #111111;\n			text-align: center;\n		}\n\n		.description2 {\n			text-align: center;\n			font-weight: 400;\n			font-size: 15px;\n			line-height: 17px;\n			color: #111111;\n			white-space: pre-wrap;\n			word-break: break-all;\n		}\n\n		> .title {\n			font-size: 30px;\n			font-weight: 800;\n			text-align: left;\n			color: #111;\n			text-align: center;\n		}\n\n		> .inputLabel {\n			height: 20px;\n			align-self: stretch;\n			flex-grow: 0;\n			font-family: NanumGothic;\n			font-size: 14px;\n			font-weight: bold;\n			font-stretch: normal;\n			font-style: normal;\n			line-height: 1.43;\n			letter-spacing: 0.4px;\n			text-align: left;\n			color: #000;\n		}\n\n		> .textFiled {\n			height: 48px;\n			line-height: 48px;\n			align-self: stretch;\n			flex-grow: 0;\n			display: flex;\n			flex-direction: row;\n			justify-content: flex-start;\n			align-items: flex-start;\n			gap: 10px;\n			padding: 12px;\n			border-radius: 8px;\n			border: solid 1px #afb1b6;\n			background-color: white;\n			width: 100%;\n			margin-top: 8px;\n			box-shadow: rgb(145 158 171 / 20%) 0px 0px 2px 0px,\n				rgb(145 158 171 / 12%) 0px 12px 24px 10px;\n		}\n\n		.link {\n			font-weight: 700;\n			font-size: 12px;\n			line-height: 10px;\n			text-decoration-line: underline;\n			color: #afb1b6;\n		}\n\n		.goJoin {\n			font-weight: 700;\n			font-size: 16px;\n			line-height: 16px;\n			text-align: center;\n\n			/* Black */\n\n			color: #000000;\n			> span {\n				background: var(--primary);\n				text-decoration-line: underline;\n				-webkit-background-clip: text;\n				-webkit-text-fill-color: transparent;\n				background-clip: text;\n				text-fill-color: transparent;\n			}\n		}\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin: 0;\n	line-height: 1.5714285714285714;\n	font-size: 13px;\n	font-weight: 400;\n	text-align: center;\n	color: #212b36;\n	margin-top: 24px;\n\n	> a {\n		margin: 0;\n		color: #212b36;\n		&:hover {\n			color: #0378ef;\n		}\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	height: ",
        "px;\n	width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var BackGround = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject());
var Layout = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject1());
var Content = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject2());
var Terms = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject3());
var EmptySpace = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject4(), function(props) {
    return props.space;
});


/***/ }),

/***/ 21594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bh": function() { return /* binding */ showEndMatch; },
/* harmony export */   "Bo": function() { return /* binding */ AppliCationStep; },
/* harmony export */   "C7": function() { return /* binding */ steperStyle; },
/* harmony export */   "K$": function() { return /* binding */ getAvailableChatMatchedExpert; },
/* harmony export */   "KA": function() { return /* binding */ getStageDataText; },
/* harmony export */   "KV": function() { return /* binding */ ExpertDataItemStep; },
/* harmony export */   "Lw": function() { return /* binding */ getStepArray; },
/* harmony export */   "SP": function() { return /* binding */ faqListExpert; },
/* harmony export */   "WH": function() { return /* binding */ canEndMatch; },
/* harmony export */   "ZU": function() { return /* binding */ canShowEER; },
/* harmony export */   "m2": function() { return /* binding */ getStage; },
/* harmony export */   "np": function() { return /* binding */ faqListClient; },
/* harmony export */   "w8": function() { return /* binding */ getExpertStep; },
/* harmony export */   "zl": function() { return /* binding */ getMatchesWithSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _src_api_match__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91088);
/* harmony import */ var _src_utils_types_stage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76906);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);






var ExpertDataItemStep;
(function(ExpertDataItemStep) {
    ExpertDataItemStep[ExpertDataItemStep["추천"] = 1] = "추천";
    ExpertDataItemStep[ExpertDataItemStep["인터뷰"] = 2] = "인터뷰";
    ExpertDataItemStep[ExpertDataItemStep["제안"] = 3] = "제안";
})(ExpertDataItemStep || (ExpertDataItemStep = {}));
var AppliCationStep;
(function(AppliCationStep) {
    AppliCationStep[AppliCationStep["LIST"] = 0] = "LIST";
    AppliCationStep[AppliCationStep["APPLICATION"] = 1] = "APPLICATION";
    AppliCationStep[AppliCationStep["CONSULTING"] = 2] = "CONSULTING";
    AppliCationStep[AppliCationStep["TEST"] = 3] = "TEST";
    AppliCationStep[AppliCationStep["PROPOSAL"] = 4] = "PROPOSAL";
})(AppliCationStep || (AppliCationStep = {}));
var getStepArray = function(userType) {
    return userType === 1 ? [
        "신청",
        "추천",
        "인터뷰",
        "계약"
    ] : [
        "추천",
        "인터뷰",
        "제안"
    ];
};
var steperStyle = {
    "svg.Mui-completed.MuiStepIcon-root": {
        color: "var(--primary)"
    },
    "svg.Mui-active.MuiStepIcon-root": {
        color: "var(--primary)"
    },
    "span.Mui-completed": {
        color: "var(--card-bg) !important"
    },
    "span.Mui-active": {
        color: "var(--card-bg) !important"
    },
    "svg.MuiStepIcon-root": {
        cursor: "pointer"
    },
    "span.MuiStepIcon-root": {
        color: "var(--card-bg)"
    },
    "span.MuiStepLabel-label.Mui-disabled": {
        color: "var(--card-bg)"
    }
};
var getAvailableChatMatchedExpert = function(matchs) {
    var availableMatchs = matchs.map(function(match) {
        return match.expertDataList.map(function(expertData) {
            var expertDataList = match.expertDataList, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(match, [
                "expertDataList"
            ]);
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, rest), {
                expertData: expertData
            });
        });
    }).flat();
    return availableMatchs.filter(function(match) {
        return !match.expertData.dateOut;
    }).filter(function(match) {
        return !match.dateStartMatch && (match.expertData.dateRequestTestSession || match.expertData.dateTestsession || match.expertData.proposalId || match.expertData.dateRequestForProposal) || match.dateEndMatch && moment__WEBPACK_IMPORTED_MODULE_2___default()(match.dateEndMatch).isAfter(moment__WEBPACK_IMPORTED_MODULE_2___default()()) || match.dateStartMatch && !match.dateEndMatch;
    }).map(function(match) {
        return {
            matchedExpertDataUuid: match.expertData.matchedExpertDataUuid,
            matchUuid: match.matchUuid,
            expertUuid: match.expertData.expertUuid,
            expert: match.expertData.expert,
            client: match.client,
            job: match.expertType
        };
    });
};
var showEndMatch = function(matchData) {
    var currentLogSettlementDate = matchData.currentLogSettlementDate;
    if (!currentLogSettlementDate) {
        return {
            isShow: false,
            text: ""
        };
    }
    var momentDateEndMatch = moment__WEBPACK_IMPORTED_MODULE_2___default()(new Date(currentLogSettlementDate));
    var result = "예상 정산일: ";
    var momentNow = moment__WEBPACK_IMPORTED_MODULE_2___default()();
    var isShow = currentLogSettlementDate ? true : false;
    var year = momentDateEndMatch.year();
    var month = momentDateEndMatch.month() + 1;
    var dateDay = momentDateEndMatch.date();
    if (dateDay <= 15) {
        var momentDate = moment__WEBPACK_IMPORTED_MODULE_2___default()("".concat(year, "-").concat(month, "-20"));
        result += momentDate.format("M월 D일 이내");
        if (momentNow.isAfter(momentDate)) {
            isShow = false;
        }
    } else {
        var momentDate1 = moment__WEBPACK_IMPORTED_MODULE_2___default()("".concat(year, "-").concat(month, "-5")).add(1, "month");
        result += momentDate1.format("M월 D일 이내");
        if (momentNow.isAfter(momentDate1)) {
            isShow = false;
        }
    }
    return {
        isShow: isShow,
        text: result
    };
};
var canShowEER = function(matchData, user) {
    if (user.userType === 1) {
        return false;
    }
    if (matchData.dateEndMatch && matchData.expertEvaluation) {
        var dateEndMatchMoment = moment__WEBPACK_IMPORTED_MODULE_2___default()(new Date(matchData.dateEndMatch)).startOf("day");
        var now = moment__WEBPACK_IMPORTED_MODULE_2___default()();
        if (now.isAfter(dateEndMatchMoment)) {
            return true;
        }
    }
    return false;
};
var canEndMatch = function(matchData, user) {
    if (user.userType === 2 || matchData.serviceGroup !== "시간제") {
        return {
            isShow: false,
            canEnd: false
        };
    }
    if (matchData.lastLogStatus !== _src_api_match__WEBPACK_IMPORTED_MODULE_0__.LogClientStatus["연장"]) {
        return {
            isShow: false,
            canEnd: false
        };
    }
    if (matchData.dateStartMatch) {
        var dateStartMatch = moment__WEBPACK_IMPORTED_MODULE_2___default()(new Date(matchData.dateStartMatch)).startOf("day");
        var now = moment__WEBPACK_IMPORTED_MODULE_2___default()();
        if (now.isBefore(dateStartMatch)) {
            return {
                isShow: false,
                canEnd: false
            };
        }
    }
    if (matchData.dateEndMatch) {
        var dateEndMatch = moment__WEBPACK_IMPORTED_MODULE_2___default()(new Date(matchData.dateEndMatch)).endOf("day");
        var now1 = moment__WEBPACK_IMPORTED_MODULE_2___default()();
        var diff = dateEndMatch.diff(now1, "days");
        if (now1.isAfter(dateEndMatch)) {
            return {
                isShow: false,
                canEnd: false
            };
        } else if (matchData.lastLogStartDate && moment__WEBPACK_IMPORTED_MODULE_2___default()().isBefore(moment__WEBPACK_IMPORTED_MODULE_2___default()(matchData.lastLogStartDate))) {
            return {
                isShow: true,
                canEnd: false
            };
        } else if (diff >= 4) {
            return {
                isShow: true,
                canEnd: true
            };
        } else {
            return {
                isShow: true,
                canEnd: false
            };
        }
    }
    return {
        isShow: false,
        canEnd: false
    };
};
var getMatchesWithSection = function(matches) {
    var ing = (matches === null || matches === void 0 ? void 0 : matches.filter(function(match) {
        return match.stage === "진행" || !match.stage;
    })) || [];
    var end = (matches === null || matches === void 0 ? void 0 : matches.filter(function(match) {
        return match.stage === "종료";
    })) || [];
    var start = (matches === null || matches === void 0 ? void 0 : matches.filter(function(match) {
        return match.stage === "개시";
    })) || [];
    return {
        ing: ing,
        end: end,
        start: start
    };
};
var getStageDataText = function(matchData, user) {
    var step = "신청완료";
    var date = "";
    var expertType = matchData.expertType;
    var expertName = user.userType === 1 ? matchData.expertType : matchData.client;
    var expertNameText = expertName ? expertName : "";
    var clientText = "";
    var cliendDate = "";
    clientText = "서비스 신청이 접수되었어요";
    // console.log("getStageDataText - matchData:", matchData);
    // detailStage가 "신청확정전"이면 무조건 해당 메시지 표시
    if (user.userType === 1 && matchData.detailStage === "신청확정전") {
        step = "신청확정전";
        date = "";
        clientText = "매칭을 최종확정해주세요";
        return {
            step: step,
            date: date,
            clientText: clientText,
            cliendDate: cliendDate,
            expertNameText: expertNameText
        };
    }
    if (user.userType === 1 && matchData.stageId === _src_utils_types_stage__WEBPACK_IMPORTED_MODULE_1__/* .MatchStage["신청완료"] */ .X["신청완료"]) {
        step = "신청완료";
        date = matchData.dateIntro ? "사전 미팅 " + moment__WEBPACK_IMPORTED_MODULE_2___default()(new Date(matchData.dateIntro)).format("YY.MM.DD HH:mm") : "";
        clientText = "서비스 신청이 접수되었어요";
    }
    if (user.userType === 1 && matchData.dateApplication) {
        step = "매칭 신청서 작성 요청";
        clientText = "매칭 신청서를 작성해주세요";
    }
    if (matchData.dateConsulting && user.userType === 1) {
        var dateConsulting = new Date(matchData.dateConsulting).getTime();
        var now = new Date().getTime();
        if (now < dateConsulting) {
            step = "상담 대기 중";
            date = moment__WEBPACK_IMPORTED_MODULE_2___default()(new Date(matchData.dateConsulting)).format("YY년 M월 D일 A h시 mm분") + " 예정";
            clientText = moment__WEBPACK_IMPORTED_MODULE_2___default()(new Date(matchData.dateConsulting)).format("YY년 M월 D일 A h시 mm분") + "\n매칭 컨설팅 진행 예정이에요";
        } else {
            step = "전문가 서칭 중";
            date = "";
            clientText = "적합한 전문가를 서칭중이에요";
        }
    }
    if (user.userType === 2) {
        if (matchData.expertDataList.some(function(d) {
            return d.dateRecommendToExpert;
        })) {
            step = "인터뷰 지원 요청";
            date = "";
            clientText = "업무요청서를 확인하고 인터뷰에 지원해주세요";
        }
        if (matchData.expertDataList.some(function(d) {
            return d.dateApplyInterview;
        })) {
            step = "인터뷰 지원 완료";
            date = "";
            clientText = "";
        }
        if (matchData.expertDataList.some(function(d) {
            return d.dateRecommend;
        })) {
            step = "고객사 검토 중";
            date = "";
            clientText = "고객사가 프로필을 검토중이에요";
        }
        if (matchData.expertDataList.some(function(d) {
            return d.dateRequestTestSession;
        })) {
            step = "인터뷰 예약 필요";
            date = "";
        }
        if (matchData.expertDataList.some(function(d) {
            return d.dateRequestConfirmTestsession;
        })) {
            step = "인터뷰 조율 중";
            date = "";
        }
        if (matchData.expertDataList.some(function(d) {
            return d.dateTestsession;
        })) {
            var dateTestsession = new Date(matchData.expertDataList.map(function(d) {
                return d.dateTestsession;
            })[0]).getTime();
            var now1 = new Date().getTime();
            if (now1 < dateTestsession) {
                step = "인터뷰 대기 중";
                date = moment__WEBPACK_IMPORTED_MODULE_2___default()(new Date(matchData.expertDataList.map(function(d) {
                    return d.dateTestsession;
                })[0])).format("YY년 M월 D일 A h시") + " 예정";
            } else {
                step = "전문가 제안 대기 중";
                date = "";
            }
        }
        if (matchData.expertDataList.some(function(d) {
            return d.proposalId;
        })) {
            step = "전문가 제안서 확인 중";
            date = "";
        }
    }
    if (matchData.expertDataList.length > 0 && user.userType === 1) {
        step = "전문가 추천";
        date = "";
        clientText = "추천 전문가를 확인해보세요";
    }
    if (matchData.dateStartMatch && (matchData.isCompleteContract == false || matchData.isCompleteFirstInvoice == false)) {
        step = "계약/결제 진행 중";
        date = "";
    }
    if (matchData.dateStartMatch) {
        step = "서비스 시작";
        date = moment__WEBPACK_IMPORTED_MODULE_2___default()(new Date(matchData.dateStartMatch)).format("YY.MM.DD") + " 시작";
        if (matchData.dateEndMatch) {
            cliendDate = moment__WEBPACK_IMPORTED_MODULE_2___default()(new Date(matchData.dateEndMatch)).add(1, "days").format("YY.MM.DD") + " 서비스 연장 예정";
        }
        clientText = "서비스를 진행중이에요";
        if (!matchData.isCompleteContract || !matchData.isCompleteFirstInvoice) {
            clientText = "계약 및 결제가 진행 중입니다!";
        }
    }
    if (matchData.stage == "종료" || (matchData.lastLogStatus === _src_api_match__WEBPACK_IMPORTED_MODULE_0__.LogClientStatus["보류"] || matchData.lastLogStatus === _src_api_match__WEBPACK_IMPORTED_MODULE_0__.LogClientStatus["이탈"]) && matchData.dateEndMatch && moment__WEBPACK_IMPORTED_MODULE_2___default()(matchData.dateEndMatch).diff(moment__WEBPACK_IMPORTED_MODULE_2___default()(), "days") < 2 && user.userType === 2 || (matchData.lastLogStatus === _src_api_match__WEBPACK_IMPORTED_MODULE_0__.LogClientStatus["보류"] || matchData.lastLogStatus === _src_api_match__WEBPACK_IMPORTED_MODULE_0__.LogClientStatus["이탈"]) && user.userType === 1) {
        step = "서비스 종료";
        date = moment__WEBPACK_IMPORTED_MODULE_2___default()(new Date(matchData.dateEndMatch)).format("YY.MM.DD") + " 종료";
        cliendDate = moment__WEBPACK_IMPORTED_MODULE_2___default()(new Date(matchData.dateEndMatch)).format("YY.MM.DD") + " 서비스 종료";
        clientText = "서비스가 종료되었어요";
    }
    return {
        cliendDate: cliendDate,
        date: date,
        step: step,
        expertType: expertType,
        expertNameText: expertNameText,
        clientText: clientText
    };
};
// 고객사 관점 스텝
var getExpertStep = function(match, expertDataItem) {
    var step = ExpertDataItemStep.추천;
    var stepDetail = "프로필 검토";
    var isDisabled = false;
    if (expertDataItem.dateRequestTestSession) {
        step = ExpertDataItemStep.인터뷰;
        stepDetail = "일정 제안 예정";
    }
    if (expertDataItem.dateRequestConfirmTestsession) {
        step = ExpertDataItemStep.인터뷰;
        stepDetail = "일정 선택";
    }
    if (expertDataItem.dateOut) {
        step = ExpertDataItemStep.인터뷰;
        stepDetail = "인터뷰 거절";
        isDisabled = true;
        return {
            step: step,
            stepDetail: stepDetail,
            isDisabled: isDisabled
        };
    }
    if (expertDataItem.dateOut && expertDataItem.proposalId && expertDataItem.dateRequestConfirmProposal) {
        step = ExpertDataItemStep.제안;
        stepDetail = "제안 거절";
        isDisabled = true;
        return {
            step: step,
            stepDetail: stepDetail,
            isDisabled: isDisabled
        };
    }
    var now = moment__WEBPACK_IMPORTED_MODULE_2___default()();
    if (expertDataItem.dateTestsession) {
        step = ExpertDataItemStep.인터뷰;
        if (now.isBefore(moment__WEBPACK_IMPORTED_MODULE_2___default()(expertDataItem.dateTestsession))) {
            if (now.isSame(moment__WEBPACK_IMPORTED_MODULE_2___default()(expertDataItem.dateTestsession), "day")) {
                stepDetail = "인터뷰 당일";
            } else {
                stepDetail = "인터뷰 D-".concat(moment__WEBPACK_IMPORTED_MODULE_2___default()(expertDataItem.dateTestsession).diff(now, "days"));
            }
        }
        if (now.isAfter(moment__WEBPACK_IMPORTED_MODULE_2___default()(expertDataItem.dateTestsession))) {
            step = ExpertDataItemStep.제안;
            stepDetail = "제안 작성 예정";
        }
    }
    if (expertDataItem.dateRequestForProposal) {
        step = ExpertDataItemStep.제안;
        stepDetail = "제안 작성 예정";
    }
    if (expertDataItem.dateRequestConfirmProposal && expertDataItem.proposalId) {
        step = ExpertDataItemStep.제안;
        stepDetail = "제안 검토";
    }
    if (match.dateStartMatch) {
        stepDetail = "서비스 진행중";
    }
    if (match.dateStartMatch && (!match.isCompleteContract || !match.isCompleteFirstInvoice)) {
        if (match.isCompleteContract && !match.isCompleteFirstInvoice) {
            stepDetail = "계약 및 결제 진행중";
        } else if (!match.isCompleteContract && match.isCompleteFirstInvoice) {
            stepDetail = "계약 진행중";
        } else if (!match.isCompleteContract && !match.isCompleteFirstInvoice) {
            stepDetail = "계약 및 결제 진행중";
        }
    }
    return {
        step: step,
        stepDetail: stepDetail,
        isDisabled: isDisabled
    };
};
var getStage = function(matchData, user) {
    var step = AppliCationStep.APPLICATION;
    if (matchData.dateConsulting) {
        step = AppliCationStep.APPLICATION;
    }
    if (matchData.dateConsulting) {
        var conDate = moment__WEBPACK_IMPORTED_MODULE_2___default()(matchData.dateConsulting).set("hours", 19);
        step = AppliCationStep.APPLICATION;
    }
    if (user.userType === 2 && matchData.expertDataList.some(function(data) {
        return data.dateRecommendToExpert || data.dateApplyInterview;
    })) {
        step = AppliCationStep.CONSULTING;
    }
    if (matchData.expertDataList.some(function(data) {
        return data.dateRecommend;
    }) && user.userType === 1) {
        step = AppliCationStep.CONSULTING;
    }
    if (matchData.expertDataList.some(function(data) {
        return data.dateRequestTestSession;
    }) && user.userType === 2) {
        step = AppliCationStep.TEST;
    }
    if (matchData.expertDataList.some(function(data) {
        return data.dateRequestConfirmTestsession;
    }) && user.userType === 1) {
        step = AppliCationStep.TEST;
    }
    if (matchData.expertDataList.some(function(data) {
        return data.dateTestsession;
    })) {
        var testDate = moment__WEBPACK_IMPORTED_MODULE_2___default()(matchData.expertDataList.map(function(data) {
            return data.dateTestsession;
        })[0]);
        step = AppliCationStep.TEST;
        if (testDate.isBefore(moment__WEBPACK_IMPORTED_MODULE_2___default()())) {
            step = AppliCationStep.PROPOSAL;
        }
    }
    if (matchData.expertDataList.some(function(data) {
        return data.proposalId;
    })) {
        step = AppliCationStep.PROPOSAL;
    }
    return step;
};
var FaqList1 = [
    {
        title: "매칭은 얼마나 걸리나요?",
        answer: "사안에 따라 다르지만 평균적으로 영업일 기준 3일 내에 최적 전문가를 추천해드리며, 7일 내에 원하는 전문가와 협업을 시작할 수 있습니다."
    },
    {
        title: "어떤 전문가와 일할 수 있나요?",
        answer: "마케팅과 관련된 모든 전문가를 보유하고 있습니다. 세부적으로는 퍼포먼스 마케터 / 콘텐츠 마케터 / 브랜드 마케터 / CRM 마케터 / 디자이너 / 카피라이터가 있습니다."
    },
    {
        title: "어떤 업무를 요청할 수 있을까요?",
        answer: "전문가와 사전에 협의된 예상 시간/업무 범위 내에서라면 어떤 업무든 요청 가능합니다. 원포인트는 전문가 '고용' 서비스 입니다. 풀타임 정규직 팀원에게 요청 주시는 것과 동일한 방식으로 협업하시면 됩니다."
    },
    {
        title: "서비스 비용은 어떻게 책정되나요?",
        answer: "전문가가 직접 4주 기준 인건비를 제안하며, 이력 및 역량 수준과 업무 난이도를 고려하여 책정하게 됩니다. 정확한 비용은 전문가 제안 시 알 수 있지만, 평균 단가는 상담 시 안내해드립니다. 전문가가 제시한 인건비 외에 추가 비용은 없습니다."
    },
    {
        title: "중간에 주당 활용 시간을 변경할 수 있나요?",
        answer: "네, 주당 활용 시간은 5시간부터 40시간까지 자유롭게 변경 가능합니다. 단, 계약 단위에 맞춰 4주 단위로 가능하며, 실제 업무 수행 시간이 계약 시간보다 자주 초과하는 경우에 한해서 4주 내에 상향 조정이 가능합니다. 모든 의사 결정은 고객사 - 전문가 합의 하에 진행됩니다."
    },
    {
        title: "전문가와 업무는 어떻게 하나요?",
        answer: "대부분의 경우 비대면 형태로 업무하지만, 전문가와의 협의 하에 대면, 비대면, 혼합 (대면+비대면) 등 다양한 형태로 진행 가능합니다."
    }, 
];
var FaqList2 = [];
var FaqList3 = [];
var FaqList4 = [];
var FaqList5 = [];
var FaqList6 = [];
var expertFaqList1 = [
    {
        title: "현재 재직중인데 전문가로 활동할 수 있을까요?",
        answer: "가능합니다. 실제로 대다수의 원포인트 전문가분들이 현직자로서 원포인트 서비스를 수행하고 계십니다. 단, 현 직장에서 정해진 근무 시간이 있는 경우 해당 시간을 반드시 피해서 활동하셔야 합니다."
    },
    {
        title: "재직중인 혹은 재직했던 회사 이력을 마스킹 처리할 수 있을까요?",
        answer: "특정 이력에 대한 마스킹이 필요한 경우 프로필 작성 시 아래와 같이 입력할 수 있습니다.\n예) 롸잇 → 탑티어 마케터 단기 고용 서비스 O사\n단, 고객사는 전문가님의 프로필을 토대로 의사결정을 하기 때문에 마스킹을 하지 않거나 최소한으로 처리하시는 것을 추천드립니다."
    },
    {
        title: "어떤 직무로 전문가 지원이 가능한가요?",
        answer: "마케팅과 관련된 직무는 어떤 직무든 가능합니다. 퍼포먼스 마케터, 콘텐츠 마케터, 브랜드 마케터, CRM 마케터, 디자이너, 카피라이터가 대표적인 예입니다. "
    },
    {
        title: "근무는 어떤 형태로 진행되나요?",
        answer: "대부분의 경우 비대면 형태로 업무하지만, 고객사 측에서 희망하는 경우 전문가와의 협의 하에 대면 또는 혼합 (대면+비대면) 근무로 진행됩니다. 업무 형태는 고객사의 업무 공고에서 확인할 수 있습니다."
    },
    {
        title: "고객사와의 매칭은 어떻게 진행되나요?",
        answer: "다양한 고객사의 업무 공고를 확인하고, 내가 원하는 곳에 원하는 만큼 지원할 수 있습니다. 사전에 프로필을 작성해두시면 빠르고 쉽게 지원할 수 있습니다."
    },
    {
        title: "매칭 이후 서비스 시작까지 어떤 절차를 거치나요?",
        answer: "고객사와의 Fit 검증을 위한 인터뷰 이후, 진행 의사가 있을시 제안서를 작성해주시면 고객사가 내용을 검토합니다. 고객사 최종 의사 결정까지는 보통 인터뷰 진행 후 영업일 기준 5일 정도 소요됩니다."
    }, 
];
var faqListClient = [
    FaqList1,
    FaqList2,
    FaqList3,
    FaqList4,
    FaqList5,
    FaqList6, 
];
var faqListExpert = [
    expertFaqList1,
    FaqList2,
    FaqList3,
    FaqList4,
    FaqList5,
    FaqList6, 
];


/***/ }),

/***/ 76906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ ExpertStage; },
/* harmony export */   "X": function() { return /* binding */ MatchStage; }
/* harmony export */ });
var MatchStage;
(function(MatchStage) {
    MatchStage[MatchStage["신청대기"] = 26] = "신청대기";
    MatchStage[MatchStage["신청완료"] = 1] = "신청완료";
    MatchStage[MatchStage["상담요청"] = 2] = "상담요청";
    MatchStage[MatchStage["상담대기"] = 3] = "상담대기";
    MatchStage[MatchStage["구체화중"] = 4] = "구체화중";
    MatchStage[MatchStage["구체화완료"] = 5] = "구체화완료";
    MatchStage[MatchStage["전문가서칭"] = 6] = "전문가서칭";
    MatchStage[MatchStage["요청서검토"] = 7] = "요청서검토";
    MatchStage[MatchStage["프로필검토"] = 8] = "프로필검토";
    MatchStage[MatchStage["인터뷰세팅"] = 9] = "인터뷰세팅";
    MatchStage[MatchStage["인터뷰대기"] = 10] = "인터뷰대기";
    MatchStage[MatchStage["제안서작성"] = 11] = "제안서작성";
    MatchStage[MatchStage["제안서검토"] = 12] = "제안서검토";
    MatchStage[MatchStage["계약입금안내"] = 13] = "계약입금안내";
    MatchStage[MatchStage["신청홀딩"] = 14] = "신청홀딩";
    MatchStage[MatchStage["온보딩진행"] = 15] = "온보딩진행";
    MatchStage[MatchStage["리텐션관리"] = 16] = "리텐션관리";
    MatchStage[MatchStage["서비스종료"] = 17] = "서비스종료";
    MatchStage[MatchStage["서비스이탈"] = 18] = "서비스이탈";
})(MatchStage || (MatchStage = {}));
var ExpertStage;
(function(ExpertStage) {
    ExpertStage[ExpertStage["서류심사"] = 19] = "서류심사";
    ExpertStage[ExpertStage["역량평가대기"] = 20] = "역량평가대기";
    ExpertStage[ExpertStage["역량평가심사"] = 21] = "역량평가심사";
    ExpertStage[ExpertStage["심층면접대기"] = 22] = "심층면접대기";
    ExpertStage[ExpertStage["심층면접심사"] = 23] = "심층면접심사";
    ExpertStage[ExpertStage["계약대기"] = 24] = "계약대기";
    ExpertStage[ExpertStage["최종합격"] = 25] = "최종합격";
})(ExpertStage || (ExpertStage = {}));


/***/ })

}]);